import { render } from "./actions.vue?vue&type=template&id=dc6316dc&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"

import "./actions.vue?vue&type=style&index=0&id=dc6316dc&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc6316dc"]])

export default __exports__